var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEqualizerBlueInverse = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 23.999h6v-12h-6zM18 7.505v16.494h6v-16.494z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009af6",
    d: "M8.998 24h6v-24h-6z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEqualizerBlueInverse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equalizer-blue-inverse.4cafb66d.svg";
export { ForwardRef as ReactComponent };